import { createSelector } from 'reselect';
import { ViewMode } from '@/pages/CompanyReport/enum';

const getViewMode = createSelector(
  [(state) => (state as any).location],
  (location): ViewMode => {
    return location.query &&
      location.query.viewmode &&
      location.query.viewmode === ViewMode.Print
      ? ViewMode.Print
      : ViewMode.Screen;
  }
);
/** Separated because of a weird circular dependency */
export const shouldSkipDefer = createSelector(
  [getViewMode],
  (viewMode): boolean => {
    return RUNTIME_ENV === 'native' || viewMode === ViewMode.Print;
  }
);
